
//
window.getSrc = ( d1x = false, d2x = false, mob = false, tab = false ) => {

	let src = d1x;
	if( DETECT.retina && d2x ){ src = d2x; }
	if( DETECT.device.tablet && !tab && d2x ){ src = d2x; }
	if( DETECT.device.mobile && mob ){ src = mob; }
	if( DETECT.device.tablet && tab ){ src = tab; }
	return src + '.webp?v='+ UNIQ_ID;

};


//
window.getVideoSrc = ( d1x = false, d2x = false, mob = false, tab = false ) => {
	let src = d1x;
	if( DETECT.retina && d2x ){ src = d2x; }
	if( DETECT.device.tablet && !tab && d2x ){ src = d2x; }
	if( DETECT.device.mobile && mob ){ src = mob; }
	if( DETECT.device.tablet && tab ){ src = tab; }
	return src;
};


//
window.detectJp = (str) =>{
	const isKata    = ( str.match(/^(?=.*[\u30A1-\u30FA]).*$/) ) ? 1 : 0;
	const isHira    = ( str.match(/^(?=.*[\u3041-\u3096]).*$/) ) ? 1 : 0;
	const isKigou   = ( str.match(/^(?=.*[\u3005-\u3006]).*$/) ) ? 1 : 0;
	const isKanji   = ( str.match(/^(?=.*[\u30e0-\u9fcf]).*$/) ) ? 1 : 0;
	const isZenkaku = ( str.match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/) ) ? 1 : 0;
	const isJa = isKata + isHira + isKigou + isKanji ? true : false;
	return isJa;
}
window.detectEn = (str) =>{
	const isEn = ( str.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~ +]*$/) ) ? true : false;
	return isEn;
}





//
window.getParam = (name, url) => {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}


//
window.clamp = (input, min, max) => {
  return Math.max(min, Math.min(input, max))
}

//
window.mapRange = (in_min, in_max, input, out_min, out_max) => {
  return ((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
}


//
window.killTweens = ( array ) => {
	for (let i = 0; i < array.length; i++) {
		if( array[i] ) array[i].kill(); array[i] = null;
	}
	array = [];
}


//
window.onPlayVideo = ( el ) =>{
	if( el ){
		const playPromise = el.play();
		// el.playbackRate = 1.2;
		if (playPromise !== undefined) {
			playPromise.then(_ => {
			})
			.catch(error => {
			});
		}
	}
}


//
window.getPxByVw = ( px ) =>{
	const fvw = 1/vW * 100 * px * (window.innerWidth/100);
	return Math.max( px, fvw );
}


//
window.getPxByVh = ( px ) =>{
	const fvh = 1/vH * 100 * px * (window.innerHeight/100);
	return Math.max( px, fvh );
}


//
window.lerp = ( from, to, ease ) => {
	return to + ( from - to ) * ease;
}






//
let resizeTimerFirst;
let resizeTimerSecond;
let resizeTimerThird;
window.onResize = ()=>{

	//
	$root.textContent = ':root {--vh:'+ window.innerHeight/100 +'px;}';

	//
	clearTimeout( resizeTimerFirst );
	resizeTimerFirst = setTimeout(()=>{

	}, 200);

	//
	clearTimeout( resizeTimerSecond );
	resizeTimerSecond = setTimeout(()=>{
	}, 400);

	//
	clearTimeout( resizeTimerThird );
	resizeTimerThird = setTimeout(()=>{
	}, 600);

}

if( !DETECT.device.any ){
	window.addEventListener('resize' , e =>{
		onResize();
	});
} else {
	window.addEventListener("orientationchange", function() {
		onResize();
	});
}



















